<template>
  <div class="header">
    <div class="container">
      <div class="logo" :class="{ 'front-page': isFrontPage } ">
        <router-link to='/'>
          <img src="@/assets/images/logo.png" />
        </router-link>
      </div>

      <div class="desktop-menus">
        <div class="top-menu">
          <li class="telephone"><a href="telephone:1484-200-9651">1 (484) 200-9651</a></li>

          <li class="search"><a href="#">Search</a></li>

          <li class="account"><a href="#">Account</a></li>

          <li class="cart">
            <router-link to='/cart'>
              Cart
              <span class="cart-counter">2</span>
            </router-link>
          </li>
        </div> <!-- /top-menu -->

        <div class="main-menu">
          <li><a href="/">Home</a></li>
          
          <li><a href="#">Product</a></li>
          
          <li><a href="#">News & Events</a></li>
          
          <li><a href="#">Company</a></li>
          
          <li><a href="/contact">Contact</a></li>
        </div> <!-- /main-menu -->
      </div> <!-- /desktop-menus -->

      <div
        @click="toggleMobileMenu"
        :class="{'active': mobileMenuOpen}"
        class="hamburger-icon"
      >
        <span />
      </div>

      <transition name="mobile-menu">
        <div v-if="mobileMenuOpen" class="mobile-menu">
          <ul>
            <li><a href="/">Home</a></li>
          
            <li><a href="#">Product</a></li>
            
            <li><a href="#">News & Events</a></li>
            
            <li><a href="#">Company</a></li>
            
            <li class="space-below"><a href="/contact">Contact</a></li>

             <li class="search"><a href="#">Search</a></li>

            <li class="account"><a href="#">Account</a></li>

            <li class="cart space-below">
              <router-link to='/cart'>
                Cart
                <span class="cart-counter">(2)</span>
              </router-link>
            </li>

            <li class="telephone"><a href="#">+1 (610) 431-7707</a></li>
          </ul>
        </div> <!-- /mobile-menu -->
      </transition>
    </div> <!-- /container -->
  </div> <!-- /header -->
</template>

<script>
export default {
  data () {
    return {
      mobileMenuOpen: false
    }
  },
  computed: {
    isFrontPage() {
      return this.$router.currentRoute.path === '/'
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    }
  }
}
</script>
